import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { InputText } from 'ui/inputs/inputText';
import { Close16 } from 'ui/icons/action/Close16';
import { colors } from 'ui/theme/colors';

import { useTranslations } from '../../hooks/useTranslations';
import { ColumnField, HttpHeaderTable, Row } from './HTTPHeaderInput.styled';
import { CustomHttpHeaders } from '../../types';

type HttpHeaderProps = {
  headers: CustomHttpHeaders;
  onChange: (value: CustomHttpHeaders) => void;
  showErrors: boolean;
};

export const testIds = {
  name: 'df-http-header-input-name',
  value: 'df-http-header-input-value',
};

const HTTPHeaderInput = ({ headers, onChange, showErrors }: HttpHeaderProps) => {
  const { t } = useTranslations();

  return (
    <HttpHeaderTable>
      {Object.values(headers).map(({ id, name, value }, idx) => {
        const nameId = `df-http-header-input-name-${id}`;
        const valueId = `df-http-header-input-value-${id}`;
        return (
          <Row key={id}>
            <ColumnField
              labelText={t('label.name')}
              inputId={nameId}
              data-idx={idx}
              data-test={testIds.name}
            >
              <InputText
                id={nameId}
                hasError={showErrors && !name}
                onChange={(val) => {
                  onChange({
                    ...headers,
                    [id]: {
                      ...headers[id],
                      name: val,
                    },
                  });
                }}
                value={name}
              />
            </ColumnField>
            <ColumnField
              labelText={t('label.value')}
              inputId={valueId}
              data-idx={idx}
              data-test={testIds.value}
            >
              <InputText
                id={valueId}
                hasError={showErrors && !value}
                onChange={(val) => {
                  onChange({
                    ...headers,
                    [id]: {
                      ...headers[id],
                      value: val,
                    },
                  });
                }}
                value={value}
              />
            </ColumnField>
            <ColumnField labelText={<>&nbsp;</>} data-idx={idx}>
              <GhostButton
                data-test={`delete-feed-${id}`}
                data-idx={idx}
                onClick={() => {
                  // Removing an input is just pruning the ID off the headers {}
                  const clone = { ...headers };
                  delete clone[id];
                  onChange(clone);
                }}
                size={BUTTON_SIZES.LARGE}
              >
                <Close16 color={colors.grey50} />
              </GhostButton>
            </ColumnField>
          </Row>
        );
      })}
    </HttpHeaderTable>
  );
};

export default HTTPHeaderInput;
